import LocalPaginated from '@/pagination/paginated';
export default interface ApiPaginated<K> {
	total: number;
	per_page: number;
	current_page: number;
	last_page: number;
	first_page_url: string;
	last_page_url: string;
	next_page_url: string;
	prev_page_url: string;
	path: number;
	from: number;
	to: number;
	data: K[];
}


export function toLocalPaginated<T>(val: ApiPaginated<T>): LocalPaginated<T> {
	return {
		total: val.total,
		perPage: val.per_page,
		currentPage: val.current_page,
		pageElements: val.data,
		lastPage: val.last_page,
	};
}

